import React, { useState, useEffect } from "react";
import axios from "axios";
import { security_key, Url } from "../../Services/Api";
import "./ECommerce.css";
import CategoryCard from "../AddOns/priceTagComponents/categoryCards";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import ProductCard from "../AddOns/priceTagComponents/productCard";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import loader from '../../Assets/Images/loader-check-three.gif';
import { RxCross1 } from "react-icons/rx";
import BottomToust from "../../Components/BottomToust/BottomToust";

export default function Stores() {

    const [currentStep, setCurrentStep] = useState(0);
    const [productsCache, setProductsCache] = useState({});
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [subLoading, setSubLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState({
        name: "",
        uid: null,
        slug: ""
    });
    const [selectedSubCategory, setSelectedSubCategory] = useState({
        name: "",
        uid: null,
        slug: ""
    });
    const fetchMainCategories = async () => {
        setCurrentStep(0);
        setLoading(true);
        try {
            const response = await axios.get(`${Url}/api/v1/productCategory/get?parent=0`);
            const getAllMainCategories = response.data.categories || [];
            setCategories(getAllMainCategories);
            console.log(getAllMainCategories);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoading(false);
        }
    };
    const fetchSubCategories = async (parent) => {
        setLoading(true);
        try {
            const response = await axios.get(`${Url}/api/v1/productCategory/get?parent=${parent}`);
            const getAllMainCategories = response.data.categories || [];
            setSubCategories(getAllMainCategories);
            console.log(getAllMainCategories);
            setCurrentStep(1);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchMainCategories();
    }, []);

    const [pagination, setPagination] = useState({
        currentPage: 0,
        perPage: 0,
        totalProducts: 0,
        totalPages: 0

    });
    const [products, setProducts] = useState(null)

    const [currentPage, setCurrentPage] = useState(null);

    const handlePageChange = async (pageNumber) => {
        setCurrentPage(pageNumber);
        await fetchProducts(selectedSubCategory.slug, pageNumber)

    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);

    };

    const handleNextPage = async () => {
        if (currentPage < pagination.totalPages) {
            const calledPage = currentPage + 1;
            setCurrentPage(calledPage)
            await fetchProducts(selectedSubCategory.slug, calledPage)
        };

    };

    const fetchProducts = async (categorySlug, page) => {
        const cacheKey = `${categorySlug}_${page}`;

        // If cache exists, use it
        if (productsCache[cacheKey]) {
            setProducts(productsCache[cacheKey].products);
            setPagination(productsCache[cacheKey].pagination);
            return;
        }

        setLoading(true);
        try {
            const response = await axios.get(`${Url}/api/v1/products/by-category?categorySlug=${categorySlug}&per_page=12&page=${page}`);
            const getAllProducts = response.data.products || [];
            const getPagination = response.data.pagination || {};

            // Set in state
            setProducts(getAllProducts);
            const newPagination = {
                currentPage: getPagination.currentPage,
                perPage: getPagination.perPage,
                totalProducts: getPagination.totalProducts,
                totalPages: getPagination.totalPages,
            };
            setPagination(newPagination);

            // Update cache
            setProductsCache(prev => ({
                ...prev,
                [cacheKey]: {
                    products: getAllProducts,
                    pagination: newPagination
                }
            }));
            setCurrentStep(2)
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoading(false);
        }
    };




    const setselectedCategoryFN = async ({ name, uid, slug }) => {
        setSelectedCategory({
            name: name,
            uid: uid,
            slug: slug
        });

        await fetchSubCategories(uid)
    }

    const setSubCategorySelection = async ({ name, uid, slug }) => {

        setSelectedSubCategory({
            name: name,
            uid: uid,
            slug: slug
        });
        await fetchProducts(slug, 1);
        setCurrentPage(1);
    }


    const [selectedProduct, setSelectedProduct] = useState(null);

    const handleSelectProduct = (item) => {
        const customProduct = {
            type: item.type,
            uid: item.uid,
            name: item.name,
            sku: item.sku,
            image: item.image?.image_url ? (Url + item.image.image_url) : "",
            sale_price: item.sale_price,
            regular_price: item.regular_price,
            manage_stock: item.manage_stock,
            attributes: item.attributes.map(attr => ({
                name: attr.name,
                option: attr.options[0]?.name || ""
            })),
            variations: item.variations.map(variation => ({
                uid: variation.uid,
                sku: variation.sku,
                image: variation.image?.image_url ? ("https://jfapi.jasonsfurnitureoutlet.com" + variation.image.image_url) : "",
                attributes: variation.attributes.map(attr => ({
                    name: attr.name,
                    option: attr.options[0]?.name || ""
                })),
                sale_price: variation.sale_price,
                regular_price: variation.regular_price,
                manage_stock: variation.manage_stock,
            }))
        };

        console.log(customProduct, "ere ate")

        setSelectedProduct(customProduct);
    };





    const [variationQuantities, setVariationQuantities] = useState({});

    const increment = (variationIndex) => {
        setSelectedProduct(prev => {
            if (variationIndex === -1) {
                // Directly update selectedProduct
                return {
                    ...prev,
                    manage_stock: {
                        ...prev.manage_stock,
                        quantity: (prev.manage_stock?.quantity || 0) + 1
                    }
                };
            } else {
                // Update inside variations
                const updatedVariations = [...prev.variations];
                updatedVariations[variationIndex] = {
                    ...updatedVariations[variationIndex],
                    manage_stock: {
                        ...updatedVariations[variationIndex].manage_stock,
                        quantity: (updatedVariations[variationIndex].manage_stock?.quantity || 0) + 1
                    }
                };

                return {
                    ...prev,
                    variations: updatedVariations
                };
            }
        });
    };


    const decrement = (variationIndex) => {
        setSelectedProduct(prev => {
            if (variationIndex === -1) {
                // Directly update selectedProduct
                return {
                    ...prev,
                    manage_stock: {
                        ...prev.manage_stock,
                        quantity: Math.max((prev.manage_stock?.quantity || 0) - 1, 0)
                    }
                };
            } else {

                // Update inside variations
                const updatedVariations = [...(prev.variations || [])]; // Protect variations

                const currentVariation = updatedVariations[variationIndex];
                if (!currentVariation || !currentVariation.manage_stock) {
                    return prev; // Don't update if manage_stock not available
                }

                updatedVariations[variationIndex] = {
                    ...currentVariation,
                    manage_stock: {
                        ...currentVariation.manage_stock,
                        quantity: Math.max((currentVariation.manage_stock?.quantity || 0) - 1, 0)
                    }
                };

                return {
                    ...prev,
                    variations: updatedVariations
                };
            }
        });
    };









    const handleInputChange = (variationId, value) => {
        const numericValue = Math.max(parseInt(value) || 0, 0); // Ensure number >= 0
        setVariationQuantities(prev => ({
            ...prev,
            [variationId]: numericValue
        }));
    };

    const statusOptions = [
        { value: "inStock", label: "In stock" },
        { value: "outStock", label: "Out of Stock" }
    ];

    const [variationStatus, setVariationStatus] = useState({});


    const handleStatusChange = (variationIndex, value) => {
        setSelectedProduct(prev => {
            if (variationIndex === -1) {
                // Update main product manage_stock
                return {
                    ...prev,
                    manage_stock: {
                        ...prev.manage_stock,
                        stock_status: value
                    }
                };
            } else {
                if (!prev?.variations?.[variationIndex]) return prev; // Safe check

                const updatedVariations = [...prev.variations];
                const currentVariation = updatedVariations[variationIndex];

                updatedVariations[variationIndex] = {
                    ...currentVariation,
                    manage_stock: {
                        ...currentVariation.manage_stock,
                        stock_status: value
                    }
                };

                return {
                    ...prev,
                    variations: updatedVariations
                };
            }
        });
    };



    const setManageStock = async () => {
        setSubLoading(true); // Show loading spinner
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };

        try {
            const response = await axios.put(`${Url}/api/v1/products/edit-stock`, selectedProduct,{headers:headers});
            if (response.status === 200) {
                handleOpenToust(`${selectedProduct.name} stock has been updated successfully!`)
                setSelectedProduct(null);
                await fetchProducts(selectedSubCategory.slug, currentPage)
            } else {
                handleOpenToust(`Something went wrong! Please check Connection.`)
            }

        } catch (error) {
            handleOpenToust(`Something went wrong! Please check Connection.`)
            setSubLoading(false);
            // ⬆️ Shows error if something wrong happens
        } finally {
            setSubLoading(false);

        }
    };



    const [openToust, setOpenToust] = useState(false);
    const [message, setMessage] = useState("");

    const handleOpenToust = (message) => {
        setOpenToust(true);
        setMessage(message);

        const timeout = setTimeout(() => {
            setOpenToust(false);
        }, 1500);
        return () => clearTimeout(timeout);
    }

    const handleCloseToust = () => {
        setOpenToust(false);
    }




    return (
        <div className="main_stores_page">
            <div className="header_Section_stores">
                {currentStep === 0 ? <div className="left_Side_header">
                    <h2>Categories</h2>
                    <p>Select Category</p>
                </div> :
                    currentStep === 1 ? <div className="left_Side_header">
                        <h2>Categories</h2>
                        <p>Select Category</p>
                    </div> :
                        currentStep === 2 ?
                            <div className="left_Side_header">
                                <h2>Products</h2>
                                <p>Select Product</p>
                            </div> : <></>
                }
                <div className="right_Side_header">
                    {currentStep !== 0 && <button onClick={() => {
                        setCurrentStep(currentStep - 1);
                    }}>
                        Back
                    </button>}
                    {currentStep !== 2 && <button onClick={() => {
                        setCurrentStep(currentStep + 1);
                    }}>
                        Next
                    </button>}
                </div>
            </div>

            {

                currentStep === 0 && <div className="mainCategories">
                    {
                        categories && categories.map((item) => {
                            return <div onClick={() => setselectedCategoryFN({ name: item.name, uid: item.uid, slug: item.slug })}>
                                <CategoryCard name={item.name} slug={item.slug} uid={item.uid} selected={selectedCategory.uid === item.uid} />
                            </div>
                        })
                    }

                </div>}

            {
                (currentStep === 1 && subCategories.length > 0) && <div className="subCategories">
                    {
                        subCategories && subCategories.map((item) => {
                            return <div
                                onClick={() => setSubCategorySelection({ name: item.name, uid: item.uid, slug: item.slug })}
                            >
                                <img className={item.uid === selectedSubCategory.uid ? "category_image selected" : "category_image"} src={Url + item.image2} />
                            </div>
                        })
                    }
                </div>
            }


            {currentStep === 2 && <div className="step_3_select_product">
                <div className="productsSelection">
                    {products &&
                        products.map((item) => {
                            //   const isSelected = selectedProducts.includes(item.uid);
                            console.log(item.variations, "here are vari")
                            return (
                                <div key={item.uid}>
                                    <ProductCard
                                        name={item.name}
                                        uid={item.uid}
                                        slug={item.slug}
                                        image={Url + item.image.image_url}
                                        sku={item.sku}
                                        // selected={isSelected}
                                        sale_price={item.sale_price}
                                        regular_price={item.regular_price}
                                        onClickFn={() => { handleSelectProduct(item); }}
                                    />
                                </div>
                            );
                        })}
                </div>
                <div className="bottom_bar_pts">
                    <div className="first"></div>
                    <Pagination
                        activePageIndex={currentPage}
                        totalPages={pagination.totalPages}
                        onPrevPage={handlePrevPage}
                        onNextPage={handleNextPage}
                        onPageChange={handlePageChange}
                    />

                </div>
            </div>}

            {selectedProduct && <div className="backdrop">
                <div className="product_popup">
                    <h2>{selectedProduct?.name}</h2>
                    <h3>SKU {selectedProduct?.sku}</h3>
                    <button className="close_btn_product" onClick={() => { setSelectedProduct(null) }} ><RxCross1 /></button>

                    {selectedProduct.type === "simple" && <div className="simple_product">

                        <div className="simple_product_details_0">
                            <img className="main_img" src={selectedProduct?.image} />
                            <div className="simple_product_details">
                                <p>Attributes</p>
                                {
                                    selectedProduct?.attributes?.map((attr) => {
                                        return (
                                            <p> - {attr.option}</p>
                                        )
                                    })
                                }
                            </div>
                            <div className="variation_status" style={{ margin: 0 }}>
                                <p>Stock Status</p>
                                {statusOptions.map((status, index) => (
                                    <label key={status.value} style={{ marginRight: '10px' }}>
                                        <input
                                            className="custom-radio"
                                            type="radio"
                                            name={`status-${index}`}  // using variation index here
                                            value={status.value}
                                            checked={selectedProduct?.manage_stock?.stock_status === status.value}
                                            onChange={(e) => handleStatusChange(-1, e.target.value)} // pass index instead of item.id
                                        />
                                        {status.label}
                                    </label>
                                ))}
                            </div>
                            <div className="variation_counter_simple">
                                <p>Stock Quantity</p>
                                <div className="variation_counter">
                                    <button onClick={() => decrement(-1)}>-</button>
                                    <input
                                        type="number"
                                        min="0"
                                        value={selectedProduct?.manage_stock?.quantity || 0}
                                        onChange={(e) => handleInputChange(selectedProduct?.uid, e.target.value)}
                                    />
                                    <button onClick={() => { increment(-1) }}>+</button>
                                </div>
                            </div>
                        </div>

                    </div>}

                    {selectedProduct.type === "variable" && <div className="variation_list">
                        {
                            selectedProduct.variations.map((item, index) => {
                                return (
                                    <div className="variation_item">
                                        <p className="sku_varia">SKU: {item.sku}</p>
                                        <div className="variation_item_content">
                                            <img src={item.image} />
                                            <div className="variation_atributes">
                                                <p>Attributes</p>
                                                {
                                                    item.attributes.map((attr) => {
                                                        return (
                                                            <p> - {attr.option}</p>
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className="variation_counter">
                                                <button onClick={() => decrement(index)}>-</button>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={selectedProduct?.variations[index]?.manage_stock?.quantity || 0}
                                                    onChange={(e) => handleInputChange(item.uid, e.target.value)}
                                                />
                                                <button onClick={() => { console.log(index); increment(index) }}>+</button>
                                            </div>
                                            {/* Status Dropdown */}
                                            <div className="variation_status">
                                                {statusOptions.map((status) => (
                                                    <label key={status.value} style={{ marginRight: '10px' }}>
                                                        <input
                                                            className="custom-radio"
                                                            type="radio"
                                                            name={`status-${index}`}  // using variation index here
                                                            value={status.value}
                                                            checked={selectedProduct?.variations[index]?.manage_stock?.stock_status === status.value}
                                                            onChange={(e) => handleStatusChange(index, e.target.value)} // pass index instead of item.id
                                                        />
                                                        {status.label}
                                                    </label>
                                                ))}
                                            </div>


                                        </div>

                                    </div>
                                )
                            })
                        }



                    </div>}
                    <div className="bottom_bar_popup">
                        <button className="cancel_btn" onClick={() => { setSelectedProduct(null) }}>Cancel</button>
                        <button className="updt_btn" onClick={() => { setManageStock() }}>Update</button>
                    </div>
                </div>
            </div>}

            {loading && <div className="overlay_loader">
                <img src={loader} />
            </div>}

            <BottomToust
                message={message}
                showMessage={openToust}
                handleCloseToust={handleCloseToust}
            />

            {subLoading && <div className="backdrop">
                <div className="loader-container">
                    <MainLoader heading1={"Updating Flyer Content"} />
                </div>
            </div>}

        </div>
    )
}